var $f5e5effd96d66274$exports = {};
"use strict";
const $f5e5effd96d66274$var$cards = Array.from(document.querySelectorAll(".features__card"));
const $f5e5effd96d66274$var$leftBtn = document.querySelector(".features__slider-left");
const $f5e5effd96d66274$var$rightBtn = document.querySelector(".features__slider-right");
const $f5e5effd96d66274$var$currentPosition = document.querySelector(".features__slider-current");
let $f5e5effd96d66274$var$currentIndex = 0;
function $f5e5effd96d66274$var$updateSlider(direction) {
    $f5e5effd96d66274$var$cards[$f5e5effd96d66274$var$currentIndex].classList.remove("visible");
    if (direction === "left") $f5e5effd96d66274$var$currentIndex = Math.max($f5e5effd96d66274$var$currentIndex - 1, 0);
    else $f5e5effd96d66274$var$currentIndex = Math.min($f5e5effd96d66274$var$currentIndex + 1, $f5e5effd96d66274$var$cards.length - 1);
    $f5e5effd96d66274$var$cards[$f5e5effd96d66274$var$currentIndex].classList.add("visible");
    $f5e5effd96d66274$var$currentPosition.textContent = `0${$f5e5effd96d66274$var$currentIndex + 1}`;
    $f5e5effd96d66274$var$leftBtn.classList.toggle("light", $f5e5effd96d66274$var$currentIndex === 0);
    $f5e5effd96d66274$var$rightBtn.classList.toggle("light", $f5e5effd96d66274$var$currentIndex === $f5e5effd96d66274$var$cards.length - 1);
}
$f5e5effd96d66274$var$leftBtn.addEventListener("click", ()=>$f5e5effd96d66274$var$updateSlider("left"));
$f5e5effd96d66274$var$rightBtn.addEventListener("click", ()=>$f5e5effd96d66274$var$updateSlider("right"));


//# sourceMappingURL=index.1d7a4d40.js.map
